import React from "react";
import "./ResultScreen.css";


const ResultScreen = (props) => (
    <div className="ResultScreen">
     {props.children} 
    </div>
  );

export default ResultScreen;